import { EyemanRole } from './roles/eyeman.role'
import { GetCataloguesItems } from './roles/catalogue.role'
import { CmpmanRole } from './roles/cmpman.role'
import { EyedesRole } from './roles/eyedes.role'
import { AdminLayoutComponent, GuardService, MenuItem, MenuMainItem } from '@surgetech-eu/core'
import { Route } from '@angular/router'
import { GalvmanRole } from './roles/galvman.role'
import { environment } from '../environments/environment'
import { Role } from './roles/roles.interface'
import { of } from 'rxjs'

const routes = []
export const RoutesForRole = {
    eyeman: EyemanRole,
    eyedes: EyedesRole,
    cmpman: CmpmanRole,
    // tslint:disable-next-line:no-string-literal
    catalog: GetCataloguesItems(window['__env']?.type || environment.type),
    galvman: GalvmanRole
}

const SecondaryPackagingMenu: MenuMainItem = {
    title: 'Secondary Packaging',
    name: 'secondary-packaging',
    icon: 'ion-ios-filing',
    children: [
        {
            route: ['/', 'secondary-packaging', 'packaging-material'],
            name: 'packaging-material',
            title: 'Packaging Material',
            icon: 'ion-cube'
        },
        {
            route: ['/', 'secondary-packaging', 'prepare-manage-packaging-item'],
            name: 'prepare-manage-packaging-item',
            title: 'Prepare / Manage Packaging Item',
            icon: 'ion-ios-paper'
        },
        {
            route: ['/', 'secondary-packaging', 'prepare-manage-packaging-kit'],
            name: 'prepare-manage-packaging-kit',
            title: 'Prepare / Manage Packaging Kit',
            icon: 'ion-ios-paper'
        },
        {
            route: ['/', 'secondary-packaging', 'data-mapping'],
            name: 'packaging-reference-mapping',
            title: 'Data Mapping',
            icon: 'ion-ios-paper'
        },
        {
            title: 'Certification',
            name: 'secondary-packaging-certification',
            icon: 'ion-document-text',
            children: [
                {
                    route: ['/', 'secondary-packaging', 'certification', 'select-and-create'],
                    title: 'Select and Create',
                    name: 'packaging-item-select-and-create-certification'
                },
                {
                    route: ['/', 'secondary-packaging', 'certification', 'upload-and-create'],
                    title: 'Upload and Create',
                    name: 'packaging-item-upload-and-create-certification'
                },
                {
                    route: ['/', 'secondary-packaging', 'certification', 'packaging-material'],
                    title: 'Packaging Material',
                    name: 'packaging-material-certification'
                }
            ]
        },
        {
            title: 'View',
            name: 'secondary-packaging-view',
            icon: 'ion-ios-paper',
            children: [
                {
                    route: ['/', 'secondary-packaging', 'view-packaging-item'],
                    title: 'Packaging Item',
                    name: 'packaging-item-view'
                },
                {
                    route: ['/', 'secondary-packaging', 'view-packaging-kit'],
                    title: 'Packaging Kit',
                    name: 'packaging-kit-view'
                }
            ]
        }
    ],
    collapsable: true,
    menuGroup: true,
    allow: context => of(context.environment.types?.includes('eyedes') || context.environment.type === 'eyedes')
}

export const getRoleRoutes = (roles: string[]): Route[] => {
    const ROLESROUTES = roles.map(role => {
        return RoutesForRole[role]
    })
    ROLESROUTES.forEach(role => {
        if (role.modules && role.modules.commonModules) {
            role.modules.commonModules.forEach(cm => {
                routes.push({
                    path: cm.url || cm.path,
                    component: AdminLayoutComponent,
                    loadChildren: () => {
                        if (cm.load) {
                            return cm.load()
                        }
                        const path = `./${role.name}/${cm.path}/${cm.path}.module`
                        return import( /* @vite-ignore */ path).then(m => m[cm.name])
                    },
                    canActivate: [GuardService]
                })
            })
        }
        if (role.modules && role.modules.externalModules) {
            role.modules.externalModules.forEach(cm => {
                routes.push({
                    path: cm.path,
                    component: AdminLayoutComponent,
                    children: [
                        {
                            path: cm.childPath,
                            component: cm.component,
                            resolve: cm.resolve,
                            data: cm.data
                        }
                    ],
                    canActivate: [GuardService]
                })
            })
        }
    })
    if (routes.length > 0) {
        routes.push({
            ...routes[0],
            path: ''
        })
    }
    return routes
}

export const getMenuItems = (roles: string[]) => {
    let rolesRoutes: Role[] = roles.map(role => RoutesForRole[role])

    let menuItems: MenuMainItem[] = rolesRoutes.map(player => ({
        title: player.title,
        name: player.name,
        icon: player.icon,
        children: [...player.pages],
        collapsable: true,
        menuGroup: true,
    }))

    // if the user has only one role plus catalog, put catalog into that role
    const catalogItem = menuItems.find(item => item.name === 'catalog')
    const isSingleRoleWithCatalog = roles.length === 2 && catalogItem
    if (isSingleRoleWithCatalog) {
        menuItems[0].children.push({
            title: catalogItem.title,
            name: catalogItem.name,
            icon: catalogItem.icon,
            children: catalogItem.children
        } as MenuItem)
        menuItems = menuItems.filter(item => item.name !== 'catalog')
    }

    if (roles.includes('eyedes')) {
        const galvmanIndex = menuItems.findIndex(item => item.name === 'galvman')
        const secondaryPackagingIndex = galvmanIndex === -1 ? menuItems.length : galvmanIndex + 1
        menuItems.splice(secondaryPackagingIndex, 0, SecondaryPackagingMenu)
    }

    return menuItems
}

export const roleRoutes = routes

